import './index.scss';
import React from 'react';
const Chevron = ({ handleClick, isExpanded, title }) => {
    return (React.createElement("button", { className: 'expander', title: title, onClick: handleClick },
        React.createElement("span", { key: +isExpanded },
            React.createElement("i", { className: isExpanded ? 'fa-solid  fa-chevron-up' : 'fa-solid fa-chevron-down' }))));
};
export default Chevron;
